import * as React from 'react';
import { getTheme, keyframes, mergeStyleSets } from '@fluentui/react';

export interface ILoadingIndicatorProps {
    label?: string;
    /** Diameter på ringen i px */
    size?: number;
}

const theme = getTheme();

const spin = keyframes({
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
});

const pulse = keyframes({
    '0%, 100%': { opacity: 0.55 },
    '50%': { opacity: 1 },
});

const classNames = mergeStyleSets({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '24px 0',
    },
    ring: {
        borderRadius: '50%',
        // Bue der toner ind fra gennemsigtig til temafarven, maskeret til en ring
        background: `conic-gradient(from 0deg, transparent 0deg, ${theme.palette.themeLighter} 90deg, ${theme.palette.themePrimary} 330deg, ${theme.palette.themePrimary} 360deg)`,
        WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 7px), #000 calc(100% - 6px))',
        mask: 'radial-gradient(farthest-side, transparent calc(100% - 7px), #000 calc(100% - 6px))',
        animationName: spin,
        animationDuration: '0.9s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
    },
    label: {
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.themePrimary,
        animationName: pulse,
        animationDuration: '1.6s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
    },
});

const LoadingIndicator: React.FunctionComponent<ILoadingIndicatorProps> = ({ label, size = 64 }) => {
    return (
        <div className={classNames.root} role="status" aria-live="polite">
            <div className={classNames.ring} style={{ width: size, height: size }} />
            {label && <div className={classNames.label}>{label}</div>}
        </div>
    );
};

export default LoadingIndicator;
